<template>
  <div class="misc-wrapper">
    <div class="misc-inner p-2 p-sm-3">
      <div class="w-100 text-center">
        <vuexy-logo :to="{ name: 'home' }" />
        <h2 class="mb-1">
          Acceso no autorizado!
        </h2>
        <p class="mb-2">
          No tienes permiso para acceder a esta página
        </p>
        <!--
          Un invitado del canal de integradores no puede abrir "home": mostrarle
          ese botón lo deja encerrado, sin navegación y sin forma de cerrar la
          sesión que le pisó la suya. Se le ofrece la salida que sí le sirve.
        -->
        <b-button
          v-if="isGuest"
          variant="primary"
          class="mb-1 btn-sm-block"
          @click="exitGuestSession"
        >Cerrar sesión</b-button>

        <b-button
          v-else
          variant="primary"
          class="mb-1 btn-sm-block"
          :to="{ name: 'home' }"
        >Volver al inicio</b-button>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable global-require */
import { BButton } from "bootstrap-vue"
import VuexyLogo from "@core/layouts/components/Logo.vue"
import store from "@/store/index"
import ability from "@/libs/acl/ability"
import { initialAbility } from "@/libs/acl/config"
import { clearGuestSession, isGuestSession } from "@/auth/guestSession"

export default {
  components: {
    BButton,
    VuexyLogo,
  },
  data() {
    return {
      downImg: require("@/assets/images/pages/not-authorized.svg"),
    }
  },
  computed: {
    isGuest() {
      return isGuestSession()
    },
    imgUrl() {
      if (store.state.appConfig.layout.skin === "dark") {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.downImg = require("@/assets/images/pages/not-authorized-dark.svg")

        return this.downImg
      }

      return this.downImg
    },
  },
  methods: {
    exitGuestSession() {
      clearGuestSession()
      // Devolver CASL a su estado inicial: si no, la instancia en memoria
      // conserva los permisos del invitado hasta que se recargue la página.
      ability.update(initialAbility)
      this.$router.replace({ name: "auth-login" })
    },
  },
}
</script>

<style lang="scss">
@import "@core/scss/vue/pages/page-misc.scss";
</style>
